import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@core/auth/authentication.service';
import { DominioCombo } from '@core/models/dominio';
import { PerfilEnum } from '@core/models/perfil';
import { RoleEnum } from '@core/models/role';
import { CargoReferenciaService } from '@core/services/cargoreferencia.service';
import { DialogService } from '@core/services/dialog.service';
import { EntidadesService } from '@core/services/entidades.service';
import { MessageService } from '@core/services/message.service';
import { PessoaService } from '@core/services/pessoa.service';
import { StatusValidacaoService } from '@core/services/status.validacao.service';
import { TipoEntidadeService } from '@core/services/tipoentidade.service';
import { UsuarioService } from '@core/services/usuario.service';
import { VinculoService } from '@core/services/vinculo.service';
import { ColumnOrder } from '@core/table/order';
import { JustificativaVinculoModalComponent } from '@modules/vinculo/components/justificativa-vinculo-modal/justificativa-vinculo-modal.component';
import { VinculosRepresentadosModalComponent } from '@modules/vinculo/components/vinculos-representados-modal/vinculos-representados-modal.component';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { NzTableSortOrder } from 'ng-zorro-antd/table';
import {
  SortCriterion,
  applyColumnSort,
  columnSortOrder,
  columnSortPriority,
  sortQueryParams
} from '@shared/util/multi-sort';
import { NgxPermissionsService } from 'ngx-permissions';
import { forkJoin, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AppSignalDataService } from 'src/app/app-signal-data.service';
import { ClickThrottle, DebouncedSearch } from '@shared/util/debounced-search.util';
import { filtrarOpcaoSemAcento } from '@shared/util/accent-insensitive-filter.util';

@Component({
  selector: 'app-vinculo-list',
  templateUrl: './vinculo-list.component.html',
  styleUrls: ['./vinculo-list.component.scss']
})
export class VinculoListComponent implements OnInit, AfterViewInit, OnDestroy {
  nzFilterOption = (): boolean => true;
  filtrarOpcaoSemAcento = filtrarOpcaoSemAcento;

  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;

  vinculoFilterForm!: FormGroup;
  filtro: any
  roleEnum = RoleEnum;
  columOrder: ColumnOrder | undefined;
  sortCriteria: SortCriterion[] = [];
  private shiftPressed = false;
  private lastSortKey: string | null = null;
  entidadeList: any[] = [];
  statusUsuario!: DominioCombo[];
  statusVinculoList: any[] = [];
  nomeFederacaoList: any[] = [];
  tipoVinculoList: any[] = [];
  vinculosVigenteList: any[] = [];
  cargoVinculosList: any[] = [];
  nomePessoaList: any[] = [];
  private readonly buscaPessoaDebounced = new DebouncedSearch();
  private readonly buscaEntidadeDebounced = new DebouncedSearch();
  private readonly buscaEntidadeRepresentadaDebounced = new DebouncedSearch();
  private readonly pesquisaThrottle = new ClickThrottle();
  private consultaSub?: Subscription;
  loadingTabela = false;
  statusValidacaoList: any[] = [];
  cargosVinculoList: any[] = [];
  pertenceList: any[] = [];
  tipoEntidadeList: any[] = [];
  entidadeRepresentadaList: any[] = [];


  size: NzButtonSize = 'large';
  contratosComErro: any[] = [];

  perfilUsuarioLogado: any;

  @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    this.pesquisar();
  }

  perfilEnum = PerfilEnum;

  constructor(
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private ngxPermissionService: NgxPermissionsService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
    private usuarioService: UsuarioService,
    private messageService: MessageService,
    private router: Router,
    private pessoaService: PessoaService,
    private statusValidacaoService: StatusValidacaoService,
    private appSignalDataService: AppSignalDataService,
    private vinculoService: VinculoService,
    private entidadeService: EntidadesService,
    private cargoReferenciaService: CargoReferenciaService,
    private modalService: NzModalService,
    private authenticationService: AuthenticationService,
    private tipoEntidadeService: TipoEntidadeService,

  ) {
    this.appSignalDataService.updateCollapsedMenuAside(true);
  }


  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();
    this.paginator.change.subscribe((val) => {
      this.consultar();
    })
    this.consultar();
    this.carregarListas();
  }

  ngOnDestroy(): void {
    this.pesquisaThrottle.destroy();
    this.buscaPessoaDebounced.cancelPending();
    this.buscaEntidadeDebounced.cancelPending();
    this.buscaEntidadeRepresentadaDebounced.cancelPending();
    this.consultaSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.vinculoFilterForm = this.formBuilder.group({
      status: [], // combo
      entidadesId: [[]], // combo multi
      entidadeRepresentadaId: [], // texto
      entidadeFederacao: [], // combo
      tipoVinculo: [], // combom multi
      vinculosVigente: [], //
      cargoVinculos: [], // combo multi
      pessoa: [], // combo
      email: [],
      pertenceA: [], // combo multi
      tipoEntidadeId:[],
      federacaoQueIndicou:[]// combo multi
    })


    this.perfilUsuario();
  }

  carregarListas(): void {
    forkJoin({
      statusValidacao: this.statusValidacaoService.consultarCombo(),
      nomeFederacao: this.entidadeService.listarPorFederacaoCombo(),
      tipoVinculo: this.vinculoService.listarPorTipoVinculo(),
      tipoEntidade: this.tipoEntidadeService.listar(),
      cargosVinculo: this.cargoReferenciaService.listar(),
      pertenceList: this.entidadeService.entidadePertenceCombo(),
    }).subscribe(({ statusValidacao, cargosVinculo, nomeFederacao, tipoVinculo, pertenceList, tipoEntidade }) => {
      this.statusValidacaoList = statusValidacao;
      this.nomeFederacaoList = nomeFederacao.filter(
        (federacao: any) => federacao.tipoAssociacao === 1,
      );
      this.tipoVinculoList = tipoVinculo;
      this.cargoVinculosList = cargosVinculo;
      this.pertenceList = pertenceList;
      this.tipoEntidadeList = tipoEntidade;
    });
  }

  pesquisar(): void {
    this.pesquisaThrottle.run(() => this.executarPesquisa());
  }

  private executarPesquisa(): void {
    this.filtro = this.vinculoFilterForm.value;
    this.paginator.reset();
    this.consultar();
  }

  consultar(): void {
    this.consultaSub?.unsubscribe();
    this.loadingTabela = true;
    this.consultaSub = this.vinculoService.consultarSort(
      this.filtro,
      this.paginator.pagination,
      sortQueryParams(this.sortCriteria),
      true
    ).pipe(
      finalize(() => {
        this.loadingTabela = false;
      })
    ).subscribe((data) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }

  rememberShift(event: MouseEvent, key: string): void {
    if (event.shiftKey) {
      event.preventDefault();
      window.getSelection()?.removeAllRanges();
    }
    this.shiftPressed = event.shiftKey;
    this.lastSortKey = key;
  }

  onColumnSort(key: string, order: NzTableSortOrder): void {
    if (!order && key !== this.lastSortKey) {
      return;
    }
    this.sortCriteria = applyColumnSort(this.sortCriteria, key, order, this.shiftPressed);
    this.shiftPressed = false;
    this.paginator.reset();
    this.consultar();
  }

  sortOrderOf(key: string): NzTableSortOrder {
    return columnSortOrder(this.sortCriteria, key);
  }

  sortPriorityOf(key: string): number | null {
    return columnSortPriority(this.sortCriteria, key);
  }

  novo(): void {
    this.router.navigate([`/vinculo/incluir`]);
  }

  editar(obj: any): void {
    if (this.ngxPermissionService.getPermission(RoleEnum.VinculoEdicao) && obj.status != 'Finalizado')
      this.router.navigate([`/vinculo/editar/${obj.id}`]);
    else
      this.router.navigate([`/vinculo/visualizar/${obj.id}`]);
  }

  reativar(obj: any): void {
    this.dialogService.confirm(`Deseja realmente reativar o vínculo <b>${obj?.id}</b>? `, () => {
      this.vinculoService.reativarVinculo(obj?.id).subscribe(() => {
        this.messageService.success('O vínculo foi reativado com sucesso!!!');
        this.consultar();
      });
    });
  }

  remover(obj: any): void {
    if (obj?.id) {
      this.vinculoService.verificarSeOVinculoEusadoComoVinculoRepresentado(obj.id).subscribe((res2: any) => {
        if (res2.length > 0) {
          this.showModalVinculoRepresentado(obj, res2);
          return; // Interrompe a execução se já caiu aqui
        }

        // Se passou pela verificação, exibe o diálogo de confirmação
        this.confirmarRemocao(obj);
      });
    }
  }

  confirmarRemocao(obj: any, possuiOutrosVinculos = false): void {
    let mensagem = `Deseja realmente remover o vínculo <b>${obj?.id}</b>?`;

    if (obj?.principal) {
      mensagem = `Deseja realmente remover o vínculo principal <b>${obj?.id}</b>?<br><b>${obj?.nomePessoa}</b> ficará sem vínculo principal.`;
    }

    if (obj?.principal && possuiOutrosVinculos) {
      mensagem += '<br>A pessoa possui outros vínculos, mas nenhum deles é o principal.';
    }

    this.dialogService.confirm(mensagem, () => {
      this.showModalJustificativaRemover(obj);
    });
  }

  showModalVinculoRepresentado(obj: any, itensLista: any): void {
    const config: ModalOptions<VinculosRepresentadosModalComponent> = {
      nzTitle: `Confirmação de Remoção do Vínculo #${obj?.id}`,
      nzContent: VinculosRepresentadosModalComponent,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '36vw',
      nzClosable: false
    };
    const modalRef = this.modalService.create(config);
    modalRef.componentInstance!.itens = itensLista;

    modalRef.afterClose.subscribe((result: any) => {
      if (result) {
        this.showModalJustificativaRemover(obj);
      }
    });
  }

  exportar(item: any) {

  }

  selectVinculosVigente(value: any): void {
    if (value != null) {
      this.vinculoService.listarPorVinculoEntidade(value).subscribe(data =>
        this.vinculosVigenteList = data);
    }
  }

  loadEntidadesSuperior(value: string): void {
    this.buscaPessoaDebounced.run(value, (termo) =>
      this.pessoaService.pessoaVinculoComboPaginado(termo).subscribe(data =>
        this.nomePessoaList = data));
  }

  loadEntidadeCombo(value: string): void {
    this.buscaEntidadeDebounced.run(value, (termo) =>
      this.entidadeService.entidadeComboPaginado(termo).subscribe(data =>
        this.entidadeList = data ?? []));
  }

  loadEntidadeRepresentadaCombo(value: string): void {
    this.buscaEntidadeRepresentadaDebounced.run(value, (termo) =>
      this.entidadeService.entidadeRepresentadaComboPaginado(termo).subscribe(data =>
        this.entidadeRepresentadaList = data ?? []));
  }

  incluir() {
    if (this.ngxPermissionService.getPermission(RoleEnum.VinculoGravacao))
      this.router.navigate([`/vinculo/incluir`]);
    else
      this.router.navigate([`/vinculo`]);
  }

  compareFn(a: { id?: any }, b: { id?: any } | { codigo?: any }): boolean {
    if (a === null || b === null) return false;
    if (typeof a === 'object' && typeof b === 'object' && 'id' in a && 'id' in b) {
      return a.id === b.id;

    } else if (typeof a === 'object' && typeof b === 'object' && 'codigo' in a && 'codigo' in b) {
      return a.codigo === b.codigo;

    } else if (typeof a === 'object' && typeof b === 'object' && 'id' in a && 'id' in b) {
      return a.id === b.id;
    }
    return false;
  }

  isExpiradaAndAtivo(item: any): boolean {
    if (!item?.fimVinculo || !item?.status) {
      return false;
    }

    const [day, month, year] = item.fimVinculo.split('/').map(Number);
    const dateFimVinculo = new Date(year, month - 1, day);

    const dateHoje = new Date();
    dateHoje.setHours(0, 0, 0, 0);

    return dateFimVinculo < dateHoje && item.status !== 'Finalizado';
  }

  isInativo(item: any): boolean {
    return item?.status === 'Finalizado';
  }

  reset() {
    this.vinculoFilterForm.reset();
    this.executarPesquisa();
  }

  showModalJustificativaRemover(obj?: any): void {
    const config: ModalOptions<JustificativaVinculoModalComponent> = {
      nzTitle: 'Informe a Justificativa: ',
      nzContent: JustificativaVinculoModalComponent,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '30vw',
      nzClosable: false
    };

    const modalRef = this.modalService.create(config);

    modalRef.afterClose.subscribe((result: any) => {
      if (result) {
        if (obj) {
          // let justificativaObj = {
          //   justificativa: result
          // };
          this.removerCallback(obj, result);
        }
      }
    });
  }

  removerCallback(obj: any, justificativa: any): void {
    this.vinculoService.removerVinculo(obj?.id, justificativa).subscribe(() => {
      let mensagem = `O vínculo <b>${obj?.id}</b> foi removido com sucesso!!!`;

      if (obj?.principal) {
        mensagem = `O vínculo principal <b>${obj?.id}</b> foi removido com sucesso!!! Por favor, insira um novo vínculo principal para <b>${obj?.nomePessoa}</b>.`;
      }

      this.messageService.success(mensagem);
      this.consultar();
      this.sugerirInativacaoPessoaSemVinculosAtivos(obj);
    });
  };

  private sugerirInativacaoPessoaSemVinculosAtivos(obj: any): void {
    if (this.perfilUsuarioLogado !== PerfilEnum.Administrador) {
      return;
    }

    const pessoaId = obj?.pessoaId ?? obj?.idPessoa;
    if (!pessoaId) {
      return;
    }

    this.vinculoService.tabelaVinculoPessoa(pessoaId).subscribe((vinculos: any) => {
      if (this.possuiVinculosAtivos(vinculos)) {
        return;
      }

      const nomePessoa = obj?.nomePessoa ?? '';
      this.dialogService.confirm(
        `A pessoa <b>${nomePessoa}</b> não possui nenhum vínculo ativo no sistema. Deseja inativá-la?`,
        () => this.inativarPessoa(pessoaId, nomePessoa),
      );
    });
  }

  private possuiVinculosAtivos(resposta: any): boolean {
    const vinculos = Array.isArray(resposta)
      ? resposta
      : Array.isArray(resposta?.content)
        ? resposta.content
        : [];

    return vinculos.some((vinculo: any) => vinculo?.status !== 'Finalizado');
  }

  private inativarPessoa(pessoaId: number, nomePessoa: string): void {
    this.pessoaService.inativar(pessoaId).subscribe(() => {
      this.messageService.success(`Pessoa <b>${nomePessoa}</b> inativada com sucesso!!!`);
    });
  }

  perfilUsuario() {
    this.perfilUsuarioLogado = this.authenticationService?.currentUserValue?.perfil?.perfil;
  }
}

